import styled from 'styled-components';

export const Container = styled.div`
  .panel {
    padding: 40px;

    h2 {
      font-size: 28px;
      margin-top: 20px;
      margin-bottom: 10px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/PrivacyPolicy/styles.js